<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Usb" class="d-icon d-icon--usb" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M2 9a1 1 0 1 0 .966.741L5.12 7.587l2.194.877a.5.5 0 0 0 .54-.11l1.411-1.412a.5.5 0 0 0 .589-.088l.5-.5a.5.5 0 0 0 0-.708l-.5-.5a.5.5 0 0 0-.708 0l-.5.5a.5.5 0 0 0-.088.589L7.38 7.413l-1.49-.596 3.61-3.61.146.147a.5.5 0 0 0 .828-.196l.5-1.5a.5.5 0 0 0-.632-.632l-1.5.5a.5.5 0 0 0-.196.828l.147.146-5.11 5.11-.596-1.49L4.74 4.466A1.001 1.001 0 0 0 6 3.5a1 1 0 1 0-1.966.259L2.146 5.646a.5.5 0 0 0-.11.54l.877 2.194-.654.654A1.001 1.001 0 0 0 2 9Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconUsb',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
